"use client";

import * as React from "react";

const FeedbackEnabledContext = React.createContext<boolean>(false);

export function FeedbackConfigProvider({
  enabled,
  children,
}: {
  enabled: boolean;
  children: React.ReactNode;
}) {
  return (
    <FeedbackEnabledContext.Provider value={enabled}>{children}</FeedbackEnabledContext.Provider>
  );
}

export function useFeedbackEnabled(): boolean {
  return React.useContext(FeedbackEnabledContext);
}
